const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新',
    desc: '7×24小时不间断追踪娱乐圈最新动态，编辑团队全天候值守，确保每一条爆料都在第一时间为您呈现，不错过任何吃瓜良机。',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-global-line',
    title: '全面覆盖',
    desc: '从影视综艺到音乐时尚，从明星八卦到行业深度，吃瓜网51覆盖娱乐全领域，一站式满足您的所有吃瓜需求。',
    color: 'text-accent-500',
    bg: 'bg-accent-100',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全访问',
    desc: '官方认证入口，多重防护保障访问稳定与信息安全。吃瓜网51官方首页地址永久有效，无需担心访问中断或信息泄露。',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-sparkling-line',
    title: '精选内容',
    desc: '专业编辑团队严格筛选每一条资讯，拒绝低质信息轰炸，只为给您呈现最有价值、最值得关注的吃瓜内容。',
    color: 'text-accent-500',
    bg: 'bg-accent-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              平台特色
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              为什么数百万吃瓜群众选择吃瓜网51
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="group bg-background-50 rounded-xl p-6 md:p-7 cursor-pointer transition-all duration-300 hover:scale-[1.02] border border-background-200/60"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${feature.bg} mb-4`}>
                  <i className={`${feature.icon} text-2xl ${feature.color}`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}